import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/supabase-client'

/**
 * Fetch market events from the shared market_events + market_locations tables.
 * Read-only — these are managed on the GMC website.
 */
export function useMarketEvents() {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchEvents = useCallback(async () => {
    setLoading(true)
    const { data, error } = await supabase
      .from('market_events')
      .select(`
        *,
        market_locations!inner(id, name, address, type, logo_url)
      `)
      .eq('market_locations.type', 'market')
      .order('date', { ascending: false })

    if (error) {
      console.error('Failed to fetch market events:', error)
    } else {
      setEvents(data || [])
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchEvents()
  }, [fetchEvents])

  return { events, loading, refresh: fetchEvents }
}
